import { render } from "./CustomerPage.vue?vue&type=template&id=ec98669c&scoped=true"
import script from "./CustomerPage.vue?vue&type=script&lang=js"
export * from "./CustomerPage.vue?vue&type=script&lang=js"

import "./CustomerPage.vue?vue&type=style&index=0&id=ec98669c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec98669c"]])

export default __exports__